import React from "react";
import AboutDriveImage1 from "../../assets/img/Who.jpg";
import AboutDriveImage2 from "../../assets/img/drive2.jpg";
import "../WhatDrivesUs.css";

export default function Who() {
  return (
    <div className="wd-img top-img">
            <img src={AboutDriveImage1} alt="Who" />
          </div>
  );
}

